import axios from 'axios'
import baseUrl from '../config'
import getToken from '../../utils/getToken'

export const fetchCampaignPartners = async ({ partnerType }) => {
  const token = getToken()

  if (partnerType === 'campaign') {
    const response = await axios.get(`${baseUrl}/campaign-partners`, {
      params: { token }
    })

    return response.data
  }

  if (partnerType === 'opportunity') {
    const response = await axios.get(`${baseUrl}/opportunity-partners`, {
      params: { token }
    })

    return response.data
  }
}

export const removeCampaignPartner = async ({ campaignId, campaignPartnerId }) => {
  const token = getToken()
  const response = await axios.delete(`${baseUrl}/campaign-partners/remove/${campaignId}`, {
    data: { token, campaignPartnerId }
  })
  return response
}

export const removeOpportunityPartner = async ({ opportunityId, opportunityPartnerId }) => {
  const token = getToken()
  const response = await axios.delete(`${baseUrl}/opportunity-partners/remove/${opportunityId}`, {
    data: { token, opportunityPartnerId }
  })
  return response
}
